import { Button, type ButtonProps } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

type CtaButtonProps = Omit<ButtonProps, "as"> & {
  href: string;
  external?: boolean;
};

export const CtaButton = ({ href, external = false, children, ...rest }: CtaButtonProps) => {
  if (!external && href.startsWith("/")) {
    return (
      <Button as={RouterLink} to={href} {...rest}>
        {children}
      </Button>
    );
  }

  return (
    <Button
      as="a"
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener" : undefined}
      {...rest}
    >
      {children}
    </Button>
  );
};
